import './product_event_table_actions.scss';

import { Box } from '../Box/box';
import { FormMultiSelect } from '../Form/Select/FormMultiSelect';
import { SearchSelectOption } from '../Form/Select/SearchSelect';
import { ListSearch } from '../ListSearch/ListSearch';
import { Spacer } from '../Spacer/Spacer';
import { Stack } from '../Stack/Stack';
import React from 'react';
import { FilterTag } from '../../model/filter';

interface Props {
  searchTerms: FilterTag[];
  categories: string[];
  categoryOptions: SearchSelectOption[];
  disablePadding?: boolean;
  showCategoriesFilter?: boolean;
  onSearchTermChange: (term: FilterTag[]) => void;
  onCategoryChange: (category: Array<string>) => void;
}

export function ProductEventTableActions({
  searchTerms,
  categories,
  categoryOptions,
  disablePadding,
  showCategoriesFilter,
  onSearchTermChange,
  onCategoryChange,
}: Props): JSX.Element {
  return (
    <Box {...(!disablePadding ? { padding: { horizontal: 24 } } : {})}>
      <Stack line align="start">
        <ListSearch
          query={searchTerms}
          onChange={(query) => onSearchTermChange(query)}
          className="product-event-table-actions__search"
        />
        {showCategoriesFilter && (
          <FormMultiSelect
            name="categories"
            options={categoryOptions}
            onChange={onCategoryChange}
            value={categories}
            icon="filter--sm"
            className="product-event-table-actions__filter"
          />
        )}
      </Stack>
      <Spacer size="default" />
    </Box>
  );
}
